import React from 'react';
import { Row, Col, FormControl, Panel, HelpBlock } from 'react-bootstrap';

class PanelIndirizzo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cap_alert: null,
      provincia_alert: null,
      editMode: (this.props.editMode)? true : null
    }

    this.validateOnChange = this.validateOnChange.bind(this);
  }

  render() {
    const { cap_alert, provincia_alert } = this.state;
    const { editMode, panIndirizzo } = this.props;

    return (
      <Col xs={12}>
        <Panel>
          <Panel.Heading>Indirizzo di consegna</Panel.Heading>
          <Panel.Body>           
            <Row className="noNegativeMargin mt-sm-1">          
              <Col xs={12} lg={5}>
                <label htmlFor="via">Via e civico</label>
                <FormControl 
                  id="via" name="via" type="text"                   
                  autoComplete="off" maxLength="255"
                  data-caption="Via (Consegna)"
                  data-separator={"%%%Indirizzo di consegna"}
                  defaultValue={editMode? panIndirizzo["via"] : ''}
                />    
              </Col>                             

              <Col xs={12} lg={4}>
                <label htmlFor="localita">Localit&agrave;</label>
                <FormControl 
                  id="localita" name="localita" type="text" 
                  onChange={(e) => {e.target.value = e.target.value.toUpperCase()}} 
                  autoComplete="off" data-caption="Località (Consegna)"
                  defaultValue={editMode? panIndirizzo["localita"] : ''}
                  maxLength="255"
                />    
              </Col> 

              <Col xs={12} lg={1}>
                <label htmlFor="provincia">Provincia</label>
                <FormControl 
                  id="provincia" name="provincia"          
                  type="text" pattern="\D{2,2}"  
                  onChange={this.validateOnChange} 
                  autoComplete="off"
                  minLength="2" maxLength="2"
                  data-caption="Provincia (Consegna)"
                  defaultValue={editMode? panIndirizzo["provincia"] : ''}
                />  
                <HelpBlock className="colorRed">{provincia_alert}</HelpBlock>  
              </Col> 

              <Col xs={12} lg={2} className="noRightPadding noLeftPadding">
                <Col xs={12} lg={8}>
                  <label htmlFor="cap">CAP</label>
                  <FormControl 
                    id="cap" name="cap" type="text"
                    onChange={this.validateOnChange} maxLength="5"   
                    pattern="\d{5,5}" autoComplete="off"
                    data-caption="CAP (Consegna)"
                    defaultValue={editMode? panIndirizzo["cap"] : ''}
                  />   
                  <HelpBlock className="colorRed">{cap_alert}</HelpBlock> 
                </Col>                
              </Col>               
            </Row>  
            <Row className="noNegativeMargin mt-sm-1">
              <Col xs={12}>
                  <HelpBlock>
                    Non è necessario compilare l'indirizzo di consegna
                    se questo risulta <strong>identico</strong> all'indirizzo del cliente.
                  </HelpBlock>
                </Col>
            </Row>   
          </Panel.Body>
        </Panel>      
      </Col>     
    );
  }  

  // Gestisce il mancato superamento della validazione
  handleInvalidField(field, errorMessage) {    
    // invalida il form (non permette il submit)
    field.setCustomValidity(errorMessage); 
    // cambia il colore dei bordi del campo
    field.classList.add('invalid-field'); 
    // mostra il messaggio di warning a video
    this.setState({[field.name+'_alert'] : [errorMessage]}); 
  }

  // Gestisce il superamento della validazione
  handleValidField(field) {
    let style = 'invalid-field';
    // Invalida il form (non permette il submit)
    field.setCustomValidity(''); 
    // Cambia il colore dei bordi del campo    
    if(field.classList.contains(style))
      field.classList.remove(style); 
    // Pulisce il messaggio di warning a video
    this.setState({[field.name+'_alert'] : ''});  
  }

  // Valida il campo e richiama il feedback appropriato
  validateOnChange(e) {        
    const field = e.target;

    if(field.value === '') {
      this.handleValidField(field);
      return;
    }

    const pattern = e.target.pattern;               
    const message = this.generateMessage(field.name);   
    
    field.value = field.value.toUpperCase();

    if(!field.value.match(pattern)) {     
      this.handleInvalidField(field, message);
    } else {
      this.handleValidField(field);
    }
  }

  // Ritorna un messaggio di errore in base al NOME del campo
  // che non ha superato la validazione del formato
  generateMessage(fieldName) {
    switch(fieldName) {
      case "cap": 
        return '5 numeri';        
      case "provincia": 
        return '2 lettere';        
      default:
        return null;
    }
  }

}

export default PanelIndirizzo;


// WEBPACK FOOTER //
// ./src/cmp/Orders/Panels/PanelIndirizzo.js